const SLIDER_THUMB_RADIUS = 4; // relative to the div's width of 212px

const SmoothingSlider = ({
    value,
    setValue,
    onMouseRealease,
    disabled,
    hide = false,
}: {
    value: number;
    setValue: (value: number) => void;
    onMouseRealease: () => void;
    disabled?: boolean;
    hide?: boolean;
}) =>
    hide ? null : (
        <div className="relative flex flex-col gap-2 xl:gap-3 mt-7 mb-4 xl:mt-11 xl:mb-2 justify-center">
            <input
                id="default-range"
                type="range"
                value={value}
                min={0}
                max={100}
                onChange={(e) => setValue(Number(e.target.value))}
                onMouseUp={onMouseRealease}
                disabled={disabled}
                className="w-full h-1 bg-blue-dark accent-blue-dark border border-white box-content rounded-lg appearance-none cursor-pointer [&::-webkit-slider-thumb]:ring-inset [&::-webkit-slider-thumb]:ring-1 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:ring-white disabled:pointer-events-none"
            />

            <label className="block text-center w-full text-sm font-semibold text-black">
                Smoothing
            </label>
            <div
                className="absolute -top-8 xl:-top-[50px]"
                style={{
                    left: `${
                        value +
                        (SLIDER_THUMB_RADIUS -
                            (value / 100) * SLIDER_THUMB_RADIUS * 2)
                    }%`,
                    transform: "translateX(-50%)",
                }}
            >
                <div className="relative flex items-center justify-center text-center text-xs xl:text-sm rounded-[4px] bg-[#000000] text-white font-semibold w-[40px] h-6 xl:h-[36px]">
                    {value.toFixed(0)}%
                    <div className="absolute w-full bottom-0 flex items-center justify-center">
                        <div className="w-0 h-0 before:content-[''] -ml-[10px] before:absolute before:border-l-[5px] before:border-r-[5px] before:border-t-[5px] before:border-l-transparent before:border-r-transparent before:border-t-[#000000]"></div>
                    </div>
                </div>
            </div>
        </div>
    );

export default SmoothingSlider;
